import { hasProperties } from '@gov-nx/core/types';
import { useMySubmissionsQuery } from './queries';
import type { ConnectToAnotherSubmissionMutation } from './useConnectToAnotherSubmissionMutation';
import { useConnectToAnotherSubmissionMutation } from './useConnectToAnotherSubmissionMutation';
import type { DisconnectFromAnotherSubmissionMutation } from './useDisconnectFromSubmissionMutation';
import { useDisconnectFromSubmissionMutation } from './useDisconnectFromSubmissionMutation';

export interface MySubmissionConnection {
	isLoading: boolean;
	submissions: { id: number; nazev: string }[];
	isConnected: boolean;

	connect: ConnectToAnotherSubmissionMutation;
	disconnect: DisconnectFromAnotherSubmissionMutation;
}

export const useMySubmissionConnection = ({
	messageId,
}: {
	messageId: number;
}): MySubmissionConnection => {
	const submissionsQuery = useMySubmissionsQuery(messageId);

	const submissions =
		submissionsQuery.data?.seznam?.filter(hasProperties(['id', 'nazev'])) ?? [];

	const disconnectMutation = useDisconnectFromSubmissionMutation(
		submissionsQuery.invalidate
	);

	return {
		isLoading: submissionsQuery.isLoading,
		isConnected: submissions.length > 0,
		submissions,
		connect: useConnectToAnotherSubmissionMutation(),
		disconnect: disconnectMutation,
	};
};
